import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=5f6349b4&scoped=true&lang=pug&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6349b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6349b4')) {
      api.createRecord('5f6349b4', component.options)
    } else {
      api.reload('5f6349b4', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=5f6349b4&scoped=true&lang=pug&", function () {
      api.rerender('5f6349b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/IconButton.vue"
export default component.exports